"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.themeParser = void 0;
const themeParser = (theme) => {
    const result = {};
    theme.designTokens.forEach((value, key) => {
        const tokenName = key.getName();
        result[tokenName] = typeof value === 'string' ? value : value.getVar();
    });
    return result;
};
exports.themeParser = themeParser;
//# sourceMappingURL=themeParser.js.map